import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import PhotographerListing from './pages/PhotographerListing';
import PhotographerProfile from './pages/PhotographerProfile';
import ClientDashboard from './pages/ClientDashboard';
import PhotographerDashboard from './pages/PhotographerDashboard';
import AssetVault from './pages/AssetVault';
import BookingFlow from './pages/BookingFlow';
import AdminPanel from './pages/AdminPanel';
import AuthPage from './pages/AuthPage';

function App() {
  return (
    <Router>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/photographers" element={<PhotographerListing />} />
        <Route path="/photographer/:id" element={<PhotographerProfile />} />
        <Route path="/book/:photographerId" element={<BookingFlow />} />
        <Route path="/client/dashboard" element={<ClientDashboard />} />
        <Route path="/photographer/dashboard" element={<PhotographerDashboard />} />
        <Route path="/vault/:bookingId?" element={<AssetVault />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;